const base64Pattern = new RegExp(/^([A-Za-z0-9+/=]|\s)*$/);
export function isBase64(input: string): boolean {
  return base64Pattern.test(input) && input.length % 4 === 0;
}
